<template>
	<bottom-sheet
		:ref="'bottomSheet'"
		v-if="canShowBottomSheet"
		@close="closeBottomSheet"
		@has-mounted="showBottomSheet"
	>
		<div class="insufficient-balance" style="padding: 20px">
			<deposit
				:injectedAmount="amount"
				:user="user"
				:title="'Insufficient Funds'"
				:desc="
					'Your current balance is too low to place this bet. Deposit now.'
				"
				:context="'error'"
				@close="closeBottomSheet"
			/>
		</div>
	</bottom-sheet>
</template>
<script>
import Deposit from "../Session/Account/Deposit.vue";
import BottomSheet from "../Shared/BottomSheet.vue";

export default {
	components: { Deposit, BottomSheet },
	data() {
		return {
			canShowBottomSheet: false,
		};
	},
	props: {
		amount: {
			type: Number,
			required: true,
		},
	},
	mounted() {
		this.openDeposit();
	},
	methods: {
		openDeposit() {
			this.canShowBottomSheet = true;
			setTimeout(() => {
				const el = document.querySelector(
					"#app > div:nth-child(8) > div > div.card > div.contents > div > div > div > div.input__container.deposit.input.account__section__input > input"
				);
				utils.focusAndOpenKeyboard(el, 0);
			}, 300);
		},
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$emit("close");
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
	},
	computed: {
		user() {
			let user = this.$store.getters.user;
			user.bonus = this.bonus;
			user.points = this.points;

			return user;
		},
	},
};
</script>

<style lang="scss">
.insufficient-balance {
	.deposit {
		margin-bottom: 0;
		&__title {
		}
		&__desc {
			color: var(--red);
		}
	}
	.global-card__type--block {
		border: initial;
		background-color: initial;
		border-radius: 0;
		padding: 0;
	}
}
</style>
